/** DB column is `visable`; accept `visible` as alias. Default true when omitted. */
export const isScreenMarkedVisible = (screen) => {
  if (screen == null) return false

  const flag = screen.visable ?? screen.visible
  if (flag === false || flag === 0 || flag === '0' || flag === 'false') return false

  return true
}
